import { render, staticRenderFns } from "./pickupForm.vue?vue&type=template&id=e1877c72&scoped=true&"
import script from "./pickupForm.vue?vue&type=script&lang=js&"
export * from "./pickupForm.vue?vue&type=script&lang=js&"
import style0 from "./pickupForm.vue?vue&type=style&index=0&id=e1877c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1877c72",
  null
  
)

export default component.exports